import { forwardRef } from "react";
import React, { useState } from "react";
import { Plan2PlateIconButton } from "./Plan2PlateIconButton";
import { ToastFn, useToast } from "../ui/Toast";
import { AxiosError } from "axios";
import { colors } from "../../theme/colors";

export const wrapSave = async (
  doSave: () => Promise<boolean>,
  toast: ToastFn,
  setLoading: (loading: boolean) => void,
) => {
  setLoading(true);
  try {
    const success = await doSave();

    if (success) {
      toast({
        title: "Speichern erfolgreich",
        status: "success",
        isClosable: true,
      });
    }
  } catch (e) {
    if (e instanceof AxiosError && !!e.response?.data) {
      const errorData = e.response.data;
      toast({
        title: `Fehler beim Speichern: ${errorData.error}`,
        description: errorData.message,
        status: "error",
        isClosable: true,
      });
      throw e;
    } else {
      toast({
        title: "Fehler beim Speichern",
        status: "error",
        isClosable: true,
      });
      throw e;
    }
  } finally {
    setLoading(false);
  }
};

export const SaveButton = forwardRef<
  HTMLButtonElement,
  {
    save: () => Promise<boolean>;
    width?: string;
    children?: React.ReactNode;
    isDisabled?: boolean;
  }
>((props, ref) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);

    const { save, ...withoutSave } = props;

    return (
      <Plan2PlateIconButton
        {...withoutSave}
        ref={ref}
        data-cy="save-button"
        isLoading={loading}
        aria-label={"save"}
        title={"Speichern"}
        backgroundColor={colors.teal}
        style={{ stroke: "white" }}
        icon={"check"}
        onClick={() => {
          wrapSave(save, toast, setLoading);
        }}
      />
    );
  },
);
